const PANEL_LOGIN_CACHE_TTL_MS = 30_000;

const createCacheEntry = () => ({
  inFlight: null,
  result: null,
  cachedAt: 0,
});

const caches = {
  admin: createCacheEntry(),
  partner: createCacheEntry(),
};

/**
 * Coalesce concurrent panel-login POSTs and reuse a recent successful result.
 * POST /admin/login and POST /admin/partner-login are session verification calls —
 * they should not fire repeatedly during the same auth bootstrap.
 */
export const dedupePanelLoginRequest = async (scope, requestFn, { forceRefresh = false } = {}) => {
  const cache = caches[scope];
  const now = Date.now();
  const isFresh =
    !forceRefresh && cache.result?.success && now - cache.cachedAt < PANEL_LOGIN_CACHE_TTL_MS;

  if (isFresh) {
    return cache.result;
  }

  if (!forceRefresh && cache.inFlight) {
    return cache.inFlight;
  }

  cache.inFlight = Promise.resolve()
    .then(requestFn)
    .then((result) => {
      if (result?.success) {
        cache.result = result;
        cache.cachedAt = Date.now();
      }
      return result;
    })
    .finally(() => {
      cache.inFlight = null;
    });

  return cache.inFlight;
};

export const clearPanelLoginCache = (scope) => {
  if (scope && caches[scope]) {
    Object.assign(caches[scope], createCacheEntry());
    return;
  }

  Object.keys(caches).forEach((key) => {
    Object.assign(caches[key], createCacheEntry());
  });
};
